/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OmitFunctions } from 'src/core/stores/types';
import { Region } from 'src/core/types/regionTypes';

type AppToEmailStoreData = OmitFunctions<Omit<AppToEmailStore, 'id'>>;

export class AppToEmailStore {
    public id: string;

    public appId: string;

    public appName: string;

    public collaborators: string[];

    public hasPredictionResource: boolean;

    public region: Region;

    constructor(id: string, data: AppToEmailStoreData) {
        this.id = id;
        this.appId = data.appId;
        this.appName = data.appName;
        this.collaborators = data.collaborators;
        this.hasPredictionResource = data.hasPredictionResource;
        this.region = data.region;
    }
}
